$(function(){
  /*swiper スライド*/
  var swiper = new Swiper('.swiper-container', {
    navigation: { 
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,  
    /*effect: 'fade',*/
    observer: true,
    observeParents: true,
    
    slidesPerView: 2,
		loopedSlides: 3,
		/*centeredSlides : true,*/
		slideToClickedSlide: true,
		spaceBetween: 20,
		slidesPerGroup: 1,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 4,
			}
		}
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
    /*pagination: {   
      el: '.swiper-pagination',    
      type: 'bullets',   
      clickable: true,
    },*/
	});
});
  

  $(function(){
  //すべてを選択した場合、.menu-listのselectedを削除し、tab-contentsをdisplay:blockにしてallにselectedを追加
	$('.all01').click(function() {
		$('.menu-list01').removeClass('selected01');
		$(this).addClass('selected01');
    $('.tab-contents01').fadeIn("slow");
		$('.tab-contents01').css('display','block');
	});
	//対象のものを選択した場合、display:blockにしてselectedを追加し、他のものと.allをdisplay:noneにする。
	$('.menu-list01').click(function() {
		$('.menu-list01').removeClass('selected01');
		$('.all01').removeClass('selected01');
		$(this).addClass('selected01');
		var index = $('.menu-list01').index(this);
		$('.tab-contents01').css('display','none');
    $('.tab-contents01').eq(index).fadeIn("slow");
		$('.tab-contents01').eq(index).css('display','block');
	});
  
  // タブ クリックしたときの関数
    $('.menu-list02').click(function() {
		$('.menu-list02').removeClass('selected02');
		$(this).addClass('selected02');
		var index = $('.menu-list02').index(this);
		$('.tab-contents02').css('display','none');
    $('.tab-contents02').eq(index).fadeIn("slow");
		$('.tab-contents02').eq(index).css('display','block');
	});
    

    /*スクロールで表示*/
$(window).on('load scroll', function(){
  if ($(window).scrollTop() > 50) {
   $('.is-flow').fadeIn(400);
   } else {
    $('.is-flow').fadeOut(400);
  }
  });

  /*スムーススクロール*/
  $('a[href^="#"]').click(function(){
    var speed = 1000;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
  
});